export default function CompanyIntroSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-[#212026] mb-8">
            Engineering Excellence Since 2004
          </h2>

          <div className="space-y-6 text-lg text-gray-800 leading-relaxed">
            <p>
              With over 21 years of expertise, Designs by DMI has been shaping
              spaces where precision meets creativity. We specialize in lighting
              design, drafting, and visualization, delivering solutions that are
              as technically sound as they are visually compelling. From Dialux
              lighting studies and AutoCAD documentation to Revit-based BIM
              modeling and photoreal renderings, our work bridges the gap
              between concept and construction.
            </p>
            <p>
              Our philosophy is simple: every project deserves a balance of
              function, beauty, and efficiency. By combining engineering rigor
              with cinematic storytelling, we provide build-ready documentation
              and presentation materials that inspire confidence—whether for
              client approvals, permits, or marketing campaigns.
            </p>
            <p>Over two decades, we’ve built a reputation for:</p>
            <ul className="text-align: left; margin-left: 20px;">
              <li>
                Accuracy you can trust — coordinated sets that minimize RFIs and
                change orders.
              </li>
              <li>
                Efficiency that delivers — quick iterations without sacrificing
                detail.
              </li>
              <li>
                Designs that perform — spaces validated by calculations yet
                elevated by aesthetics.
              </li>
            </ul>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16 pt-16 border-t border-[#dbcfbf]/30">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-[#e18033] mb-2">
                50+
              </div>
              <div className="text-sm font-medium text-[#889d8f]">
                Projects Completed
              </div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-[#e18033] mb-2">
                21+
              </div>
              <div className="text-sm font-medium text-[#889d8f]">
                Years Experience
              </div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-[#e18033] mb-2">
                30+
              </div>
              <div className="text-sm font-medium text-[#889d8f]">
                Happy Clients
              </div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-[#e18033] mb-2">
                98%
              </div>
              <div className="text-sm font-medium text-[#889d8f]">
                Client Satisfaction
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
